// Lib
import {
    ACCOUNT,
    DATA_ACCESS,
    INTEGRATIONS,
    NO_ACTIVE_SOCIAL_PROFILE,
    PLATFORM_OPTIONS,
    SECURITY,
    SOCIAL_PROFILES,
    SUBSCRIPTION_INVOICES,
    THEMES,
    USERS_ROLES
} from '@/lib/routes/privateRoutes';

export const pagesWithoutSocialProfile = [
    ACCOUNT,
    DATA_ACCESS,
    PLATFORM_OPTIONS,
    SECURITY,
    SOCIAL_PROFILES,
    SUBSCRIPTION_INVOICES,
    THEMES,
    USERS_ROLES,
    NO_ACTIVE_SOCIAL_PROFILE,
    INTEGRATIONS
];
